__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "ops-main-micro-frontend";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.8.7", () => (Promise.all([__webpack_require__.e(70), __webpack_require__.e(489), __webpack_require__.e(416), __webpack_require__.e(693)]).then(() => (() => (__webpack_require__(6070))))));
			register("@devpaps/paps-icon", "1.0.4", () => (Promise.all([__webpack_require__.e(611), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(1611))))));
			register("@react-oauth/google", "0.12.1", () => (Promise.all([__webpack_require__.e(416), __webpack_require__.e(308)]).then(() => (() => (__webpack_require__(6426))))));
			register("@sentry/react", "8.41.0", () => (Promise.all([__webpack_require__.e(2), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(7002))))));
			register("axios", "1.7.2", () => (__webpack_require__.e(676).then(() => (() => (__webpack_require__(4676))))));
			register("classnames", "2.3.2", () => (__webpack_require__.e(184).then(() => (() => (__webpack_require__(4184))))));
			register("clsx", "2.0.0", () => (__webpack_require__.e(410).then(() => (() => (__webpack_require__(1410))))));
			register("date-fns", "3.6.0", () => (__webpack_require__.e(146).then(() => (() => (__webpack_require__(3146))))));
			register("graphql-ws", "5.14.3", () => (Promise.all([__webpack_require__.e(217), __webpack_require__.e(693)]).then(() => (() => (__webpack_require__(6217))))));
			register("graphql", "16.7.1", () => (__webpack_require__.e(707).then(() => (() => (__webpack_require__(5707))))));
			register("i18next-browser-languagedetector", "7.1.0", () => (__webpack_require__.e(349).then(() => (() => (__webpack_require__(6071))))));
			register("i18next-chained-backend", "4.4.0", () => (__webpack_require__.e(629).then(() => (() => (__webpack_require__(1580))))));
			register("i18next-http-backend", "2.4.2", () => (__webpack_require__.e(554).then(() => (() => (__webpack_require__(3554))))));
			register("i18next", "22.4.15", () => (Promise.all([__webpack_require__.e(307), __webpack_require__.e(165)]).then(() => (() => (__webpack_require__(2307))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(486).then(() => (() => (__webpack_require__(6486))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(3935))))));
			register("react-error-boundary", "4.0.13", () => (Promise.all([__webpack_require__.e(416), __webpack_require__.e(630)]).then(() => (() => (__webpack_require__(4511))))));
			register("react-i18next", "12.3.1", () => (Promise.all([__webpack_require__.e(416), __webpack_require__.e(598)]).then(() => (() => (__webpack_require__(7117))))));
			register("react-router-dom", "6.14.2", () => (Promise.all([__webpack_require__.e(250), __webpack_require__.e(655), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(9655))))));
			register("react", "18.2.0", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))));
			register("styled-components", "6.0.4", () => (Promise.all([__webpack_require__.e(753), __webpack_require__.e(416), __webpack_require__.e(353)]).then(() => (() => (__webpack_require__(3753))))));
			initExternal(1880);
			initExternal(488);
			initExternal(1297);
			initExternal(6964);
			initExternal(4360);
			initExternal(8954);
			initExternal(9677);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};